import styled from 'styled-components'

export const AgendaNewCard = styled.div`
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 20px;

  .agenda-new {
    &-header {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      gap: 0.5rem;
      border-radius: 20px 20px 0 0;
      padding: 1.5rem 1rem;

      &-profile-image {
        position: relative;
        padding: 10px 10px;
        img {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background-color: #ffffff;
          object-fit: contain;
          object-position: center;
        }
        &::after {
          content: '';
          position: absolute;
          width: 58px;
          height: 58px;
          left: calc(((58px - 44px - 20px) / 2) * -1);
          top: calc(((58px - 44px - 20px) / 2) * -1);
          background: #e5e5e5 0 0 no-repeat padding-box;
          border-radius: 50%;
          z-index: -1;
        }
      }

      &-profile-new-name {
        font-size: 20px;
        line-height: 24px;
        font-weight: bold;
        margin-bottom: 0.5rem;
      }

      &-profile-link {
        &:hover {
          stroke: #000000 !important;
        }
        margin-left: auto;
        padding-right: 0.5rem;
        &-svg {
          fill: none;
          stroke: #22a7ea;
          stroke-width: 5;
          transition-duration: 200ms;
        }
        a {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 6px;
          font: normal normal medium 16px/20px Euclid Circular A;
          color: #22a7ea;
          transition-duration: 200ms;
          &:hover {
            color: #000000;
            .agenda-new-header-profile-link-svg {
              stroke: #000000 !important;
            }
          }
        }
        img {
          width: 18px;
        }
      }
    }

    &-body {
      padding: 0 1.5rem;
      &-image {
        width: 100%;
        overflow: hidden;
        border-radius: 10px;
        margin-bottom: 0.5rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }

      &-post-info {
        font: normal normal normal 14px/18px Euclid Circular A;
        color: #707b93;
        margin: 0 0.2rem;
      }
      &-post-detail {
        margin: 0 0.2rem;
        &-title {
          font: normal normal 600 22px/25px Euclid Circular A;
          color: #2e2f31;
          margin: 1rem 0;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        &-text {
          font: normal normal normal 16px/20px Euclid Circular A;
          color: #2e2f31;
          margin-top: 1rem;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
`
